// extracted by mini-css-extract-plugin
export default {"linksInfo":"styles_linksInfo__EI356","links":"styles_links__uh-zI","link":"styles_link__DVd-b","linkHolder":"styles_linkHolder__s5d7B"};